import { LSLetter } from "../../ruleSets/lushootseedSampler";
import { Say2 } from "../widgets/Say2";
import { lushootLetterNames } from "./lushootseedKeys";
import { SayLS } from "./SayLS";

/** show an alphabet with sample words for each letter */
export function TableOfSamples(props: { letters: LSLetter[] }) {
  return (<table>
    <thead>
      <tr>
        <th>letter</th>
        <th>name</th>
        <th>ipa</th>
        <th>sample</th>
        <th>word</th>
      </tr>
    </thead>
    <tbody>
      {props.letters.map((letter, i) => <LetterRows letter={letter} key={i} />)}
    </tbody>
  </table>)
}

/** show one or more rows with info about the letter & any sample words using it */
function LetterRows(props: { letter: LSLetter }) {
  const samples = props.letter.samples;
  const rest = samples.length > 1 ? samples.slice(1) : [];

  // first row has info about letter & first sample
  // remaining rows have the rest of the samples
  return (<>
    <tr>
      <td>{props.letter.letter}</td>
      <td>{lushootLetterNames[props.letter.letter]}</td>
      <td><Say2>{`/${props.letter.ipa}/`}</Say2></td>
      {samples[0] === undefined ? <></>
        : <><td><SayLS>{samples[0].word}</SayLS></td><td>{samples[0].meaning}</td></>}
    </tr>

    {rest.map((sample, i) => (<tr key={i}>
      <td></td><td></td><td></td>
      <td><SayLS>{sample.word}</SayLS></td>
      <td>{sample.meaning}</td>
    </tr>))}
  </>);
}
